<template>
  <div class="pc-course-series">
    <!-- 课程系列头部管理 -->
    <div class="pc-course-series-header">
      <h2>课程系列管理</h2>
      <div class="pc-button-group">
        <el-button
          v-show="isEditting == false"
          class="pc-btn addbtn"
          @click="addSeries"
        >
          添加
        </el-button>
        <el-button
          @click="manageSeries"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
        <el-button @click="save" v-show="isEditting" class="pc-btn">
          完成
        </el-button>
      </div>
    </div>
    <!-- 课程系列管理 -->
    <ul class="series-list">
      <li
        v-for="(item, index) in seriesList"
        :key="index"
        class="series-item"
        :class="item.status != 1 ? 'lost' : ''"
        @click="goSeriesPage(item.id, item.chinese_name)"
      >
        <div class="series-item-content">
          <p class="name">{{ item.chinese_name }}</p>
          <p class="number">
            课程数：
            <span>
              {{ item.lecture_count }}
            </span>
          </p>
        </div>

        <div v-if="item.status != 1" class="lost-icon">无效</div>
        <!-- 点击编辑显示的删除样式 -->
        <div
          v-show="isEditting"
          @click="deleteSeries(item.id)"
          class="choice-delete"
        >
          <i class="el-icon-circle-close"></i>
        </div>
      </li>
    </ul>
    <ul class="pagination" v-if="total > 12">
      <li
        v-for="(item, index) in Math.ceil(total / 12)"
        :key="index"
        :class="page == index + 1 ? 'choicePage' : ''"
        @click="changePage(index)"
      ></li>
    </ul>
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import { getLectureSeriesList_Api,deleteLectureSeries_Api } from "../../../../apis/lecture.api";
export default {
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      seriesList: [],
      page: 1,
      total: 0,
      deleteSeriesId: 0,
    };
  },
  components: {
    DeleteDialog,
  },
  mounted() {
    this.getLectureSeriesList(this.page);
  },
  methods: {
    getLectureSeriesList(page, hint) {
      getLectureSeriesList_Api(page).then((res) => {
        this.seriesList = res.data;
        this.total = res.count;
        hint ? this.$global.success(this, hint) : "";
      });
    },
    addSeries() {
      this.$router.push({
        path: "/admin/seriesdetail",
        name: "seriesdetail",
        query: { method: "add" },
      });
    },
    manageSeries() {
      this.isEditting = true;
    },
    save() {
      this.isEditting = false;
    },
    deleteSeries(id) {
      this.deleteSeriesId = id;
      this.deleteDialogVisible = true;
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    goSeriesPage(id) {
      if (this.isEditting == false) {
        this.$router.push({
          path: "/admin/seriesdetail",
          query: { id: id, method:'update' },
          name: "seriesdetail",
        })
      }
    },
    deleteConfirm() {
      deleteLectureSeries_Api({series_id:this.deleteSeriesId}).then(()=>{
         this.getLectureSeriesList(this.page);
         this.deleteDialogVisible = false;
      })
    },
    changePage(index) {
      this.page = index + 1;
      this.getLectureSeriesList(this.page, "获取系列成功");
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-course-series {
  @include box-model;
  .pc-course-series-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
      .addbtn {
        background: $test;
        color: $blueBtna;
      }
    }
  }

  .series-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 30px;
    height: 180px;
    .series-item {
      width: 16%;
      margin-right: 0.6%;
      height: 60px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      cursor: pointer;
      .series-item-content {
        width: 80%;
        margin: 0;
        padding: 11px 10px 0 11px;
        .name {
          @include ellipsis;
          width: 100%;
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          color: #434343;
          line-height: 14px;
        }
        .number {
          margin: 0;
          font-size: 10px;
          margin-top: 12px;
          span {
            display: inline-block;
            height: 14px;
            line-height: 14px;
            color: $lightenYellow;
          }
        }
      }
      .choice-delete {
        width: 20%;
        height: 100%;
        display: flex;
        justify-content: center;
        border-radius: 0px 4px 4px 0;
        /deep/ .el-icon-circle-close {
          color: $timeBtn;
          align-self: center;
        }
        /deep/ .el-icon-circle-close:hover {
          color: $lightenYellow;
        }
      }
    }
    .lost {
      opacity: 0.44;
      position: relative;
      overflow: hidden;
      .lost-icon {
        position: absolute;
        width: 60px;
        top: 6px;
        left: -16px;
        text-align: center;
        background: $blueBtna;
        font-size: 10px;
        font-weight: 400;
        color: $base-color;
        transform: rotate(-45deg);
      }
    }
  }

  // // 课程系列换页
  .pagination {
    display: flex;
    justify-content: center;
    li {
      cursor: pointer;
      width: 34px;
      height: 5px;
      background: $schoolTagBorder;
      margin-right: 10px;
    }
    .choicePage {
      background: $blueBtna;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/lecture/components/seriesList.vue